import extractEmail from './utils/extractEmail';
import extractGivenId from './utils/extractGivenId';
import replaceParamValues from './utils/replaceParamValues';
import { addOutlookBaseDomain } from './addOutlookBaseDomain';
import { initializeMessageCommunication } from 'extension-communication/lib/handlers/initializeMessageCommunication';
import { isOpx } from 'owa-opx/lib/isOpx';
import { logUsage } from 'owa-analytics';
import { OpxSessionInfo, setLayout, setOpxHostData } from 'owa-config';
import { setCdnContainer } from 'owa-config/lib/defaultCdnSettings';
import { shouldShowEdgeHeader } from 'bootstrap/lib/utils/shouldShowEdgeHeader';

//TODO: need to check, this should be olkextension
addOutlookBaseDomain();
setCdnContainer('olkextension/');
setLayout('Phone');

const initialPath = location.pathname;
const calendarRegex = /view\/(agenda|day)\/event/;
try {
    let pathname = location.pathname;
    let isModified = false;
    if (
        pathname.indexOf('/id/') >= 0 &&
        pathname.indexOf('/itemId/') >= 0 &&
        pathname.indexOf('/immutableItemId/') == -1
    ) {
        isModified = true;
        pathname = pathname + '/immutableItemId/';
        const itemIdParam = extractGivenId(pathname, 'itemId/', '/immutableItemId');
        pathname = pathname + itemIdParam + '/';
    }
    if (
        pathname.indexOf('@') >= 0 && //Unless there is an email, do not do anything
        pathname.indexOf('/id/') >= 0 &&
        pathname.indexOf('/itemId/') >= 0 &&
        pathname.indexOf('/immutableItemId/') >= 0
    ) {
        isModified = true; //The first step of removing the email is needed for all consumer accounts.
        const emailID = extractEmail(pathname);
        const folderParam = extractGivenId(pathname, emailID + '/', '/id');
        const idParam = extractGivenId(pathname, 'id/', '/itemId');
        const itemIdParam = extractGivenId(pathname, 'itemId/', '/immutableItemId');
        const immIdParam = extractGivenId(pathname, 'immutableItemId/', '/?');
        pathname = pathname.replace(emailID + '/', '');
        pathname = pathname.replace(folderParam, replaceParamValues(folderParam));
        pathname = pathname.replace(idParam, replaceParamValues(idParam));
        pathname = pathname.replace(itemIdParam, replaceParamValues(itemIdParam));
        pathname = pathname.replace(immIdParam, replaceParamValues(immIdParam));
    } else if (
        pathname.indexOf('/id/') >= 0 &&
        pathname.indexOf('/itemId/') >= 0 &&
        pathname.indexOf('/immutableItemId/') >= 0
    ) {
        isModified = true; //The first step of removing the email is needed for all consumer accounts.
        let folderParam;
        //Check if /0/ is present when extracting folderID, as /0/ is present between module and folderID
        if (pathname.indexOf('mail/0/') >= 0) {
            folderParam = extractGivenId(pathname, 'mail/0/', '/id');
        } else {
            folderParam = extractGivenId(pathname, 'mail/', '/id');
        }
        const idParam = extractGivenId(pathname, 'id/', '/itemId');
        const itemIdParam = extractGivenId(pathname, 'itemId/', '/immutableItemId');
        const immIdParam = extractGivenId(pathname, 'immutableItemId/', '/?');
        pathname = pathname.replace(folderParam, replaceParamValues(folderParam));
        pathname = pathname.replace(idParam, replaceParamValues(idParam));
        pathname = pathname.replace(itemIdParam, replaceParamValues(itemIdParam));
        pathname = pathname.replace(immIdParam, replaceParamValues(immIdParam));
    } else if (pathname.search(calendarRegex) >= 0) {
        isModified = true;
        const eventId = extractGivenId(pathname, 'event/', '/details');
        pathname = pathname.replace(eventId, replaceParamValues(eventId));
    }

    if (isModified) {
        history.replaceState({}, '', pathname + location.search);
    }
} catch (err) {
    logUsage('consumerRedirectionError', { ip: initialPath, er: err });
}

const showExtensionHeader = shouldShowEdgeHeader();
if (!isOpx()) {
    setOpxHostData(
        Promise.resolve({ hostApp: 'outlookedge', hostedScenario: 'outlookedge' } as OpxSessionInfo)
    );
    // Set the css custom property ahead of time to avoid flickering
    showExtensionHeader &&
        document.documentElement.style.setProperty('--additionalTopHeaderHeight', '56px');
}

/**
 * Registers listeners to listen messages from extension and send message to extension
 */
initializeMessageCommunication();
